import { RestError } from "../../services/rest-service/RestService";
import { useQuery } from "react-query";
import GlobalDataService, { defaultTimezoneValue } from "../../services/global-data-service/GlobalDataService";
import { IReferenceTimeZoneDTO } from "../../services/global-data-service/Models";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";

const keys = {
    all: ["timezones"],
    timezones: (
    ) => [
            ...keys.all,
            "data", {
            }
        ]
};

const placeholderData: IReferenceTimeZoneDTO[] = [defaultTimezoneValue];

export type UseTimzonesQueryParameters = BaseUseQueryParameters<IReferenceTimeZoneDTO[]>;

export function useTimezones(params?: UseTimzonesQueryParameters) {
    return useQuery<IReferenceTimeZoneDTO[], RestError>(
        keys.timezones(),
        ({ signal }) => {
            return GlobalDataService.getTimeZones(signal);
        },
        {
            enabled: params?.enabled,
            onError: params?.onError,
            onSuccess: params?.onSuccess,
            staleTime: Infinity,
            // SPR - This creates a new array on every iteration
            // placeholderData: [defaultTimezoneValue]
            placeholderData: placeholderData
        }
    );
}